import type { FC } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { useExpectedBacklinksParams } from "app/pages/digital-marketing/backlinks/shared/BacklinksUtils";
import type { IRangeValues } from "pro-features/components/filtersPanel/src/RangeFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { DTSFilter } from "./dts-range";
import { ExactUrlFilter } from "./exact-url/ExactUrlFilter";

export const BacklinksDomainsTableFilters: FC = () => {
    const params = useExpectedBacklinksParams();
    const dtsFrom = params?.dtsFrom ?? "";
    const dtsTo = params?.dtsTo ?? "";
    const targetUrl = params?.targetUrl ?? "";

    const handleVolumeFilterChange = (data: IRangeValues) => {
        void proNavigator.updateParams({ dtsFrom: data.fromValue, dtsTo: data.toValue }, { replace: true });
    };

    const handleExactUrlFilterChange = (newExactUrl?: string) => {
        void proNavigator.updateParams({ targetUrl: newExactUrl }, { replace: true });
    };

    return (
        <Flex
            flexDirection="row"
            gap="8px"
            alignItems="center"
        >
            <DTSFilter
                onChange={handleVolumeFilterChange}
                tableFilters={{ fromValue: dtsFrom, toValue: dtsTo }}
                minFromValue={0}
                maxFromValue={100}
                minToValue={parseInt(dtsFrom, 10) || 0}
                maxToValue={100}
                tooltipText="digitalsuite.backlinks.table.column.domain_inlink_rank.tooltip"
                filterTextKey="digitalsuite.backlinks.table.column.domain_inlink_rank"
                selectedText={{
                    VOLUME: "DA",
                    AT_LEAST: "DA >",
                    UP_TO: "DA <",
                }}
            />
            <ExactUrlFilter
                exactURL={targetUrl}
                onFilterChange={handleExactUrlFilterChange}
            />
        </Flex>
    );
};
